/**
 * BacktestBanner — the plan §11 "Global" banner, G12: "Trust is earned by
 * track record: the backtest in section 12 must pass before output is used
 * live; until then a person reviews every output (the UI shows a 'backtest
 * not passed' banner, WP-80)."
 *
 * Reads GET /api/contracts/health (useContractsHealth). Shown whenever
 * `backtest_passed` is absent or false, OR the health check is still loading,
 * OR it failed outright — hidden ONLY on a confirmed `backtest_passed ===
 * true`. That is one fail-safe rule, not three: `health` is null while
 * loading and on error (useContractsHealth never surfaces a stale
 * last-known-good value), and `undefined !== true` covers "absent" and
 * "false" alike, so `health?.backtest_passed !== true` is the single
 * expression every one of those states satisfies.
 */
import { AlertTriangle } from 'lucide-react';
import { useContractsHealth } from '../hooks/useContractsHealth';

export function BacktestBanner({ siteId }: { siteId: string | null }) {
  const { health } = useContractsHealth(siteId);
  const showBanner = health?.backtest_passed !== true;

  if (!showBanner) return null;

  return (
    <div
      role="status"
      data-testid="backtest-banner"
      className="border-b border-amber-200 bg-amber-50 px-4 py-2 dark:border-amber-800 dark:bg-amber-900/20 sm:px-6 lg:px-8"
    >
      <div className="flex items-center gap-2 text-sm text-amber-800 dark:text-amber-300">
        <AlertTriangle size={16} className="flex-shrink-0 text-amber-600 dark:text-amber-400" aria-hidden="true" />
        <span>Backtest not passed: a person reviews every output</span>
      </div>
    </div>
  );
}

export default BacktestBanner;
